import { render, staticRenderFns } from "./AssessmentDepository.vue?vue&type=template&id=3193cad3&scoped=true"
import script from "./AssessmentDepository.vue?vue&type=script&lang=js"
export * from "./AssessmentDepository.vue?vue&type=script&lang=js"
import style0 from "./AssessmentDepository.vue?vue&type=style&index=0&id=3193cad3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193cad3",
  null
  
)

export default component.exports